// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_GET_URL_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/getUrl.js");
var ___CSS_LOADER_URL_IMPORT_0___ = require("../../images/arrow-down.svg");
exports = ___CSS_LOADER_API_IMPORT___(false);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
exports.push([module.id, ".arrow-icon[data-v-6ba1251c]{position:relative;padding-right:20px}.arrow-icon[data-v-6ba1251c]:after{content:\"\";position:absolute;display:block;width:18px;height:9px;background:url(" + ___CSS_LOADER_URL_REPLACEMENT_0___ + ") no-repeat center center;right:0;top:50%;margin-top:-4px;transition:.2s transform ease}.arrow-icon-up[data-v-6ba1251c]:after{transform:rotate(180deg)}", ""]);
// Exports
module.exports = exports;
